import React, { PureComponent } from 'react';

import { Cell } from 'formlabs-web-components/Grid';
import { Card } from 'formlabs-web-components/Media';

import './CareersTeamsList.module.css';

class CareersDepartment extends PureComponent {
  render() {
    return (
      <Cell largeSize="8" mediumSize="12">
        <Card headline={this.props.name}>
          {this.props.jobs.map(job => {
            return (
              <div key={job.id} styleName="listing">
                <a href={job.absolute_url}>
                  <span>{job.title}</span>
                </a>
                <p>{job.location.name}</p>
              </div>
            );
          })}
        </Card>
      </Cell>
    );
  }
}

export default CareersDepartment;
